<template>
  <div class="px-4 pb-5">
    <div class="d-flex justify-center">
      <h3
        style="font-weight: 500"
        class="pb-5"
      >
        {{ title }}
      </h3>
    </div>
    <v-text-field
      dense
      v-model="name"
      label="Nom de l'organisation"
    />
    <div class="d-flex justify-start py-4">
      <v-text-field
        class="pr-6"
        type="number"
        dense
        v-model="maxUsers"
        label="Nombre maximum d'utilisateurs"
      />
      <v-text-field
        class="pl-6"
        type="number"
        dense
        v-model="maxGroups"
        label="Nombre maximum de groupes"
      />
    </div>
    <div class="d-flex justify-end">
      <v-btn
        text
        color="primary"
        @click.stop="onSave"
      >
        Sauvegarder
      </v-btn>
    </div>
  </div>
</template>
<script>
import { OrganizationService } from './OrganizationService';

export default {
  name: 'OrganizationForm',
  props: {
    organization: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: '',
      name: '',
      maxGroups: undefined,
      maxUsers: undefined,
    };
  },
  created() {
    this.updateTitle();
    this.updateOrgInfo();
  },
  methods: {
    async onSave() {
      const organizationService = new OrganizationService();

      if (this.name && this.isNewOrg()) {
        await organizationService.createOrganization(
          this.name,
          parseInt(this.maxUsers, 10),
          parseInt(this.maxGroups, 10),
        );
      }

      if (this.name && !this.isNewOrg()) {
        const payload = {
          name: this.name,
          maxUsers: parseInt(this.maxUsers, 10),
          maxGroups: parseInt(this.maxGroups, 10),
        };
        await organizationService.updateOrganization(this.organization.id, payload);
      }

      this.$emit('saved');
    },
    updateTitle() {
      if (this.isNewOrg()) {
        this.title = 'Création d\'une nouvelle organisation';
      } else {
        this.title = 'Modification d\'une organisation';
      }
    },
    updateOrgInfo() {
      if (!this.organization) return;

      if (this.organization.name) {
        this.name = this.organization.name;
      }
      if (this.organization.maxUsers) {
        this.maxUsers = this.organization.maxUsers;
      }
      if (this.organization.maxGroups) {
        this.maxGroups = this.organization.maxGroups;
      }
    },
    isNewOrg() {
      return this.organization.id === undefined;
    },
  },
  watch: {
    organization() {
      this.updateTitle();
      this.updateOrgInfo();
    },
  },
};
</script>
